import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { PreRenderService } from '../../services/pre-render.service';
import { HasSubscriptions } from '../../components/has-subscriptions';
import { MetaTagService } from '../../services/meta-tag.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent extends HasSubscriptions implements OnInit, OnDestroy {
  private _destroyed = false;
  constructor(
    private prerenderService: PreRenderService,
    private router: Router,
    private metaTagsService: MetaTagService
  ) {
    super();
  }

  ngOnInit() {
    this.prerenderService.setPreRenderFlag(404);
    // This is needed to detect that the url changed but we ended up on 404 page again.
    if (this.prerenderService.isServerMode) {
      this.addSub(this.router.events.subscribe(e => {
        if (e instanceof NavigationEnd && !this._destroyed) {
          this.prerenderService.setPreRenderFlag(404);
        }
      }));
    }
    this.metaTagsService.setPageTitle('meta-tags.page-not-found.title', {});
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._destroyed = true;
  }

}
